// removed by extract-text-webpack-plugin
module.exports = {"buttonSection":"communitySection-module_buttonSection_2_y02","img":"communitySection-module_img_n9h3H"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/communitySection/communitySection.module.css
// module id = 461
// module chunks = 1 3